import moment from 'moment';
import { MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';
import { Center, Column, Divider, Row, Text } from '~/commonComponents';
import { useJobProfessionDisplay } from '~/hooks';
import { CloseCircleSolidIcon, ContinueCircleIcon } from '~/images/icons';
import { ProfessionTypeEnum } from '~/models';
import { Colors } from '~/themes/colors';
import './styles.scss';
import { IDraftJobCardProps } from './Types';

export const DraftJobCard = ({
  id,
  lastSavedAt,
  office,
  officeSelected,
  professionType,
  subProfession,
  title,
  onDeleteDraft,
}: IDraftJobCardProps) => {
  const navigate = useNavigate();

  const professionToDisplay = useJobProfessionDisplay({
    profession: professionType || ProfessionTypeEnum.RDH,
    subProfession,
  });

  const handleContinueClick = () => {
    navigate(`/permanent-jobs/postings/${id}/create`);
  };

  const handleDeleteClick = (e: ReactMouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    onDeleteDraft?.(id);
  };

  return (
    <Row
      alignItems="center"
      backgroundColor={Colors.white}
      borderRadius={10}
      boxShadow="0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 1px 3px 1px rgba(0, 0, 0, 0.15)"
      className="draft-job-card"
      display="grid"
      gridTemplateColumns="1fr 20%"
      paddingBlock={12}
      position="relative"
      onClick={handleContinueClick}
    >
      <Column gap={6} marginLeft={36}>
        <Text bold textDecoration="underline">
          {title || 'UNTITLED'}
        </Text>
        <Text>{officeSelected ? office?.name || 'No Office Selected' : 'No Office Selected'}</Text>
        <Row alignItems="center" gap={12}>
          <Text>
            {professionType
              ? professionToDisplay || 'No Professional Type Selected'
              : 'No Professional Type Selected'}
          </Text>
          <Divider width={1} height={12} marginVertical={0} />
          <Text color={Colors.neutral_400} fontSize={14} italic>
            Draft saved on {moment(lastSavedAt).format('ddd, MMM D, YYYY')}
          </Text>
        </Row>
      </Column>
      <Row
        alignItems="center"
        className="continue-btn"
        gap={8}
        justifyContent="flex-end"
        marginRight={36}
        role="button"
      >
        <ContinueCircleIcon />
        <Text bold fontSize={18}>
          Continue
        </Text>
      </Row>
      <Center
        className="delete-btn"
        cursor="pointer"
        filter="drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.1))"
        position="absolute"
        right={-8}
        role="button"
        top={-8}
        onClick={handleDeleteClick}
        padding={1}
      >
        <CloseCircleSolidIcon size={32} />
      </Center>
    </Row>
  );
};
